import { useTranslation, Trans } from "react-i18next";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, A11y } from "swiper/modules";

function OurAchievments() {
  const { t } = useTranslation();

  const achievements = [
    { title: "about_us.39", subtitle: "about_us.39_1" },
    { title: "about_us.40", subtitle: "about_us.40_1" },
    { title: "about_us.41", subtitle: "about_us.41_1" },
    { title: "about_us.42", subtitle: "about_us.42_1" },
    { title: "about_us.43", subtitle: "about_us.43_1" },
    { title: "about_us.44", subtitle: "about_us.44_1" },
    { title: "about_us.45", subtitle: "about_us.45_1" },
    { title: "about_us.46", subtitle: "about_us.46_1" },
    { title: "about_us.47", subtitle: "about_us.47_1" },
    { title: "about_us.48", subtitle: "about_us.48_1" },
    { title: "about_us.49", subtitle: "about_us.49_1" },
    { title: "about_us.50", subtitle: "about_us.50_1" },
    { title: "about_us.51", subtitle: "about_us.51_1" },
    { title: "about_us.52", subtitle: "about_us.52_1" },
    { title: "about_us.53", subtitle: "about_us.53_1" },
    { title: "about_us.54", subtitle: "about_us.54_1" },
    { title: "about_us.55", subtitle: "about_us.55_1" },
  ];

  const chunkSize = 6;

  const chunkedAchievements = [];
    for (let i = 0; i < achievements.length; i += chunkSize) {
    chunkedAchievements.push(achievements.slice(i, i + chunkSize));
  }


  const Item = ({ item }) => (
    <div className="flex gap-[12px] xl:gap-[40px]">
      {/* SVG */}
      <svg
        className="flex-shrink-0 mt-[3px]"
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <path d="M12.6914 18H5.30859V13.7109H12.6914V18Z" fill="#65CDBF"/>
        <path d="M16.9108 2.10938V3.54516C16.9108 5.48821 15.755 7.27787 13.918 8.05395C14.1904 7.58988 14.3989 7.05059 14.5441 6.42938C15.353 5.71676 15.8561 4.67367 15.8561 3.54516V3.16406H14.8014V2.10938H16.9108Z" fill="#65CDBF"/>
        <path d="M4.08375 8.055C2.30379 7.30406 1.08984 5.53676 1.08984 3.54516V2.10938H3.19922V3.16406H2.14453V3.54516C2.14453 4.68035 2.64727 5.72238 3.45762 6.43359C3.60316 7.0534 3.81164 7.59199 4.08375 8.055Z" fill="#65CDBF"/>
        <path d="M14.8008 0V1.05469H14.2734C13.9827 1.05469 13.7461 1.29129 13.7461 1.58203V3.87141C13.7461 7.61168 12.4182 8.37844 11.449 8.93813C10.8538 9.2816 10.582 9.43875 10.582 10.1995C10.582 10.9691 10.8475 12.6562 11.6367 12.6562H6.36328C7.15254 12.6562 7.41797 10.9691 7.41797 10.1995C7.41797 9.43629 7.14621 9.27949 6.55066 8.93602C5.58141 8.37703 4.25391 7.61133 4.25391 3.87141V1.58203C4.25391 1.29129 4.0173 1.05469 3.72656 1.05469H3.19922V0H14.8008Z" fill="#65CDBF"/>
      </svg>

      <div>
        <p className="text-[#000000B2] inter font-[500] text-[16px]">
          <Trans>{t(item.title)}</Trans>
        </p>
        <p className="text-[#000000B2] inter font-[400] text-[16px]">
          <Trans>{t(item.subtitle)}</Trans>
        </p>
      </div>
    </div>
  );

  return (
    <div className="relative overflow-hidden mt-[80px] xl:mt-[140px]">
      <div className="max-w-[1220px] mx-[20px] xl:mx-auto">
        <p className="text-[20px] xl:text-[48px] poppins font-[500] text-[#061A77] xl:max-w-[480px] leading-[1.2]">
          <Trans>{t("about_us.38")}</Trans>
        </p>
        <div className="mt-[20px] xl:hidden">
          <Swiper
            spaceBetween={16}
            slidesPerView={1}
            modules={[Autoplay, Navigation, A11y]}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            loop
            navigation={{
              prevEl: ".achiv-prev",
              nextEl: ".achiv-next",
            }}
          >
            {chunkedAchievements.map((group, index) => (
                <SwiperSlide key={index}>
                <div className="grid grid-cols-1 gap-[16px]">
                    {group.map((item) => (
                    <Item key={item.title} item={item} />
                    ))}
                </div>
                </SwiperSlide>
            ))}
          </Swiper>
        <div
            className="
                flex items-center justify-between gap-3 py-2
                overflow-hidden xl:overflow-visible mt-[20px]
            "
            >
                <button
                    className="achiv-prev w-[46px] h-[22px] xl:w-[56px] xl:h-[22px]
                    rounded-[2px] border border-[#061A77] text-[#061A77]
                    flex items-center justify-center
                    hover:bg-[#061A77] hover:text-white transition"
                    type="button"
                >
                    ←
                </button>
                <button
                    className="achiv-next w-[46px] h-[22px] xl:w-[56px] xl:h-[22px]
                    rounded-[2px] bg-[#061A77] text-white
                    flex items-center justify-center
                    hover:opacity-90 transition"
                    type="button"
                >
                    →
                </button>
            </div>
        </div>

        {/* DESKTOP */}
        <div className="hidden xl:grid grid-cols-3 mt-[40px] gap-y-[10px]">
          {achievements.map((item) => (
            <Item key={item.title} item={item} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default OurAchievments;
